<template>
  <div id="navigation">
    <b-navbar class="is-primary">
      <template #brand>
        <b-navbar-item tag="router-link" :to="{ path: '/' }">
          <img
            class="pandora-logo"
            src="@/assets/image/logo_elkatsu.svg"
            alt="えるかつ！"
          />
        </b-navbar-item>
      </template>
      <template v-if="isAuthenticated && !isPerformer && !isHideNavigation" #start>
        <b-navbar-item
          v-for="(route, index) in routeList"
          :key="index"
          tag="router-link"
          :to="{ path: route.path }"
        >
          {{ route.name }}
        </b-navbar-item>
      </template>
      <template v-if="!isHideNavigation" #end>
        <!-- 会員登録時にHeader profileを表示させない -->
        <HeaderProfile v-if="isAuthenticated && isCreated" />
        <div v-if="!isAuthenticated || !isCreated" class="button__headerwrap">
          <button disabled style="background:#ccc;border-radius:9999px;padding: .3em 1em;font-size:14px;font-weight: 600;">無料会員登録</button>
          <router-link class="button__headerlogin" to="/signin">
            入店する
          </router-link>
        </div>
      </template>
    </b-navbar>
  </div>
</template>

<script>
import HeaderProfile from '@/components/HeaderProfile';

export default {
  name: 'Navigation',
  components: {
    HeaderProfile
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters['auth/isAuthenticated'];
    },
    isCreated() {
      return this.$store.getters['user/isCreated'];
    },
    isPerformer() {
      return this.$store.getters['user/isPerformer'];
    },
    isHideNavigation() {
      return this.$route.path === '/email-confirmed' || this.$route.path === '/movie'
    },
    routeList() {
      return [
        {
          name: '出勤中',
          path: '/live/explore'
        },
        {
          name: '出勤予定',
          path: '/live/upcoming'
        },
        {
          name: 'あーかいぶ',
          path: '/live/archive'
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
